// extracted by mini-css-extract-plugin
module.exports = {"Select":"FileFormats_Select__1G6Yq"};